import { bgConstants } from "../constants/businessGroup.constants";
const initialState = {
  businessGroup: [],
  openLegend: false,
  quarter: 1,
  filterOption: []
};

const BusinessGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case bgConstants.GET_BUSI_SUCCESS:
      let status = 0;
      action.props.filterOption.forEach((element, index) => {
        if (element.stats == 1) {
          status = element.value;
        }
      });
      return {
        ...state,
        businessGroup: action.props.businessGroup,
        filterOption: action.props.filterOption,
        isFavorites: action.props.isFavorites,
        quarter: status
      };
    case bgConstants.LEGEND_TOGGLE:
      return {
        ...state,
        openLegend: !state.openLegend
      };
    case bgConstants.GET_BG_FILTER:
      const filterArray = Object.keys(action.bgroups.filterOption).map(
        i => action.bgroups.filterOption[i]
      );

      return {
        ...state,
        businessGroup: action.bgroups.businessGroup,
        filterOption: filterArray,
        quarter: parseInt(action.bgroups.quarter)
      };
    default:
      return state;
  }
};

export default BusinessGroupReducer;
